import React, { useEffect, useState } from "react";
import * as Images from "../../../../utilities/images";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { socketInstance } from "../../../components/common/socketNew";
import { useDispatch } from "react-redux";
import { showLiveComments } from "../../../../redux/slices/user";
import { useAuthSelector } from "../../../../redux/selector/auth";
import AgoraRTC from "agora-rtc-sdk-ng";
import { toast } from "react-toastify";
import CustomModal from "../../../components/modals/modal";
import ConfirmModal from "./confirmModal";
import { MenuItem, Select } from "@mui/material";

const LiveStreaming = () => {
  const authSelector = useAuthSelector();
  const navigate = useNavigate();
  const toastId = React.useRef(null);
  const userId = authSelector?.userLogin?.data?.user;
  const location = useLocation();
  const dispatch = useDispatch();
  const [totalViews, setTotalViews] = useState("");
  const [totalRating, setTotalRating] = useState("");
  const [showCommentsSection, setshowCommentsSection] = useState(false);
  const [showUsersCommentsSection, setShowUserCommentSection] = useState(true);
  const [liveCommentsList, setLiveCommentsList] = useState([]);
  const [cameraList, setCameraList] = useState([]);
  const [selectedCamera, setSelectedCamera] = useState(null);

  const channelParameters = {
    localAudioTrack: null,
    localVideoTrack: null,
    remoteAudioTrack: null,
    remoteVideoTrack: null,
    remoteUid: null,
  };
  const [key, setKey] = useState(Math.random());

  const [modalDetail, setModalDetail] = useState({
    show: false,
    title: "",
    flag: "",
  });
  const handleOnCloseModal = () => {
    setModalDetail({
      show: false,
      title: "",
      flag: "",
    });
    setKey(Math.random());
  };

  const { id } = useParams();
  const [uidId, setUidId] = useState("");
  const [appId, setAppId] = useState("");
  const [channelName, setChannelName] = useState("");
  const [tokenId, setToeknId] = useState("");
  const [roomID, setRoomID] = useState("");
  const agoraEngine = AgoraRTC.createClient({ mode: "live", codec: "vp9" });

  useEffect(() => {
    if (location?.state?.uid) {
      setUidId(location?.state?.uid);
      setAppId(location?.state?.appId);
      setChannelName(location?.state?.channel);
      setToeknId(location?.state?.tokenId);
      setRoomID(location?.state?.roomID);
      localStorage.setItem("liveStream", JSON.stringify(location.state));
    } else if (localStorage.getItem("liveStream")) {
      let location = localStorage.getItem("liveStream");
      location = JSON.parse(location);
      setUidId(location?.uid);
      setUidId(location?.uid);
      setAppId(location?.appId);
      setChannelName(location?.channel);
      setToeknId(location?.tokenId);
      setRoomID(location?.roomID);
    }
  }, []);

  const getCameraList = async () => {
    try {
      const devices = await AgoraRTC.getDevices();
      const cameras = devices.filter((device) => device.kind === "videoinput");
      setCameraList(cameras);
      if (cameras.length > 0) {
        setSelectedCamera(cameras[0].deviceId);
      }
    } catch (error) {
      console.error("Error fetching camera list:", error);
    }
  };

  const newStartVideoProcess = async () => {
    const wrapper = document.getElementById("localVideoPlayer");
    const localPlayerContainer = document.createElement("div");

    const options = {
      appId: appId,
      channel: channelName,
      token: tokenId,
      uid: uidId,
      role: "host",
    };
    await agoraEngine.setClientRole(options.role);
    await agoraEngine.join(
      options.appId,
      options.channel,
      options.token,
      options.uid
    );

    wrapper.append(localPlayerContainer);
    channelParameters.localAudioTrack =
      await AgoraRTC.createMicrophoneAudioTrack();
    //channelParameters.localVideoTrack = await AgoraRTC.createCameraVideoTrack();
    channelParameters.localVideoTrack = await AgoraRTC.createCameraVideoTrack({
      encoderConfig: "720p_2",
      cameraId: selectedCamera,
    });
    if (options.role == "host") {
      await agoraEngine.publish([
        channelParameters.localAudioTrack,
        channelParameters.localVideoTrack,
      ]);

      channelParameters.localVideoTrack.play(localPlayerContainer);
    }
  };

  const handleCameraChange = async (event) => {
    const newSelectedCamera = event.target.value;
    setSelectedCamera(newSelectedCamera);

    const wrapper = document.getElementById("localVideoPlayer");
    const localPlayerContainer = document.createElement("div");

    if (channelParameters.localVideoTrack) {
      channelParameters.localVideoTrack.stop();
      await channelParameters.localVideoTrack.close();
    }
    wrapper.append(localPlayerContainer);
    channelParameters.localAudioTrack =
      await AgoraRTC.createMicrophoneAudioTrack();
    channelParameters.localVideoTrack = await AgoraRTC.createCameraVideoTrack({
      cameraId: newSelectedCamera,
    });
    channelParameters.localVideoTrack.play(localPlayerContainer.current);
  };
  useEffect(() => {
    getCameraList();
  }, []);

  useEffect(() => {
    if (socketInstance && roomID) {
      // socketInstance.connect();
      socketInstance.on("connection", (response) => {});
      socketInstance.on("sync_data", (response) => {
        setTotalViews(response.totalUsers);
        setTotalRating(response.totalrating);
      });
      broadcastEvent();
      socketInstance.on("add_comment", (data) => {
        getAllLiveComments(roomID);
      });
      getAllLiveComments(roomID);

      return () => {
        socketInstance.disconnect();
      };
    }
  }, [roomID]);

  const broadcastEvent = () => {
    socketInstance.emit("broadCast", {
      class_id: id,
    });
    socketInstance.on("liveClassReact", (data) => {});
  };
  const handleShowCommentBoxes = () => {
    setshowCommentsSection(true);
    setShowUserCommentSection(false);
  };
  const handleCross = () => {
    setshowCommentsSection(false);
    setShowUserCommentSection(true);
  };

  const handleSendComments = (event) => {
    let addComment = event.target[0].value;
    event.preventDefault();
    if (!addComment) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error("Please add comment!");
        return false;
      }
    } else {
      socketInstance.emit("add_comment", {
        room_id: roomID,
        comment: addComment,
      });
      socketInstance.on("add_comment", (data) => {
        if (data.statusCode === 200) {
          event.target.reset();
          setLiveCommentsList((prevData) => {
            const isIdPresent = prevData.some(
              (item) => item?.id === data?.data?.id
            );
            if (!isIdPresent) {
              return [...prevData, data.data];
            } else {
              return prevData; // Return the previous data without any changes
            }
          });
        } else {
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.error("Comment is too long");
            return false;
          }
        }
      });
      socketInstance.on("sync_data", (response) => {
        setTotalViews(response.totalUsers);
        setTotalRating(response.totalrating);
      });
    }
  };

  const getAllLiveComments = (roomID) => {
    let params = {
      room_id: roomID,
    };
    dispatch(
      showLiveComments({
        ...params,
        cb(res) {
          if (res?.data) {
            const sortedData = [...res?.data?.data?.commentlist].sort(
              (a, b) => new Date(a?.updatedAt) - new Date(b?.updatedAt)
            );
            setLiveCommentsList(sortedData);
          } else {
          }
        },
      })
    );
  };

  useEffect(() => {
    if ((agoraEngine, uidId)) {
      newStartVideoProcess();
    }
    return async () => {
      // channelParameters.localAudioTrack.close();
      // channelParameters.localVideoTrack.close();
      await agoraEngine.leave();
    };
  }, [agoraEngine, uidId]);

  const handleEndCall = async () => {
    // channelParameters.localAudioTrack.close();
    // channelParameters.localVideoTrack.close();
    await agoraEngine.leave();
    setModalDetail({
      show: true,
      title: "confirm",
      flag: "confirm",
    });
    setKey(Math.random());
  };

  useEffect(() => {
    window.onpopstate = () => {
      handleGoBack();
    };
  });

  const handleGoBack = () => {
    socketInstance.emit("end_class", {});
    socketInstance.on("end_class", (data) => {
    });
    navigate("/admin/classes");
    window.location.reload();
  };

  const getChat = (chatData) => {
    let count = 0;
    let res = [];

    chatData.map((data, idx) => {
      if (data?.created_by?.id != 1) {
        res.push(
          <div key={idx} className="chatBoxOuter border-26">
            <div className="chatBoxInner">
              <div className="d-flex">
                <span>
                  <img
                    className="user"
                    src={data?.created_by?.profile_image}
                    alt=""
                  />
                </span>

                <div className="ms-3">
                  <p className="colorWhite subtext mb-0">
                    {data?.created_by?.full_name}
                  </p>
                  <p className="colorWhite subtext mb-0 textLiveStreaming">
                    {data?.comment}
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
        count++;
      }
    });
    res = res?.slice(Math.max(res?.length - 6, 0));
    // res.sort();
    return res;
  };

  return (
    <>
      <>
        <section className="liveStreaming">
          <div className="container-fluid px-0">
            <div className="livestreamingOuter">
              <div id="localVideoPlayer" className="localVideoPlayer"></div>
              <div
                className="livevedio"
                style={{ display: "flex", width: "100vw", height: "100vh" }}
              >
                <div id="localStream" className="adminvedioContainer">
                  <div className="flexRow">
                    <div className="adminvedioInner">
                      <button className="button mb-0" onClick={handleGoBack}>
                        <span className="youtubeIcon">
                          {" "}
                          <img
                            src={Images.backarrowwhite}
                            alt=""
                            onClick={handleGoBack}
                          />
                        </span>
                        Go Back{" "}
                      </button>

                      <div className="d-flex align-items-center topboxOuter">
                        <div className="subtextOuter">
                          <p className="subtext mb-0">
                            <span className="me-2">
                              <img
                                className="yellowStar"
                                src={Images.yellowstar}
                                alt=""
                              />
                            </span>
                            {totalRating}
                          </p>
                        </div>
                        <div className="subtextOuter">
                          <p className="subtext mb-0">
                            <span className="me-2">
                              <img src={Images.pinkeye} alt="" />
                            </span>
                            {totalViews}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-end">
                    <div className="liveStreamingFooter">
                      <div className="liveText">
                        <p className="">
                          <span className="redDot"></span>LIVE
                        </p>
                      </div>
                      <div className="Buttons buttons-select">
                        <button
                          className="endCallButton login-btn me-3 bg-danger"
                          type="button"
                          id="leave"
                          onClick={(e) => handleEndCall(e)}
                        >
                          <img
                            className="muteIcon"
                            src={Images.endcall}
                            alt=""
                          />
                          End Live Streaming
                        </button>
                        {cameraList?.length > 0 ? (
                          <>
                            <label className="me-2" htmlFor="cameras">
                              Select Camera:{" "}
                            </label>
                            <Select
                              className="select-camera"
                              value={selectedCamera || ""}
                              label="Age"
                              onChange={handleCameraChange}
                            >
                              {" "}
                              {cameraList.map((camera) => (
                                <MenuItem
                                  key={camera?.deviceId}
                                  value={camera?.deviceId}
                                >
                                  {" "}
                                  {camera?.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </>
                        ) : (
                          ""
                        )}
                      </div>

                      {showUsersCommentsSection && (
                        <div className="chatBoxSend">
                          {getChat(liveCommentsList)}
                        </div>
                      )}
                      <div className="mszBox">
                        <img
                          className="w-100"
                          src={Images.msgbox}
                          alt=""
                          onClick={(e) => handleShowCommentBoxes(e)}
                        />
                      </div>
                    </div>
                    {showCommentsSection && (
                      <div className="col-md-4 p-0">
                        <div className="msgBox">
                          <div className="msgBoxHead">
                            <div className="d-flex align-items-center">
                              <div className="msg_box">
                                <img
                                  className="w-100"
                                  src={Images.msgbox}
                                  alt=""
                                />
                              </div>
                              <span className="colorWhite font-26">
                                Messages
                              </span>
                            </div>
                            <div className="">
                              <img
                                className="img-fluid"
                                src={Images.crossCircle}
                                alt=""
                                onClick={(e) => handleCross(e)}
                              />
                            </div>
                          </div>

                          <div className="pt-4 px-5 pb-4 chat_Box">
                            {liveCommentsList?.map((data) => {
                              return (
                                <>
                                  {userId?.id == data?.created_by?.id ? (
                                    <div className="chatBoxOuter border-26 replyChatBox">
                                      <div className="chatBoxInner chatboxReply">
                                        <span>
                                          <img
                                            className="user"
                                            src={
                                              data?.created_by?.profile_image
                                            }
                                            alt=""
                                          />
                                        </span>
                                        <div className="me-3">
                                          <p className="colorWhite subtext mb-0">
                                            {data?.created_by?.full_name}
                                          </p>
                                          <p className="colorWhite subtext mb-0 textLiveStreaming">
                                            {data?.comment}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="chatBoxOuter border-26">
                                      <div className="chatBoxInner">
                                        <div className="d-flex">
                                          <span>
                                            <img
                                              className="user"
                                              src={
                                                data?.created_by?.profile_image
                                                  ? data?.created_by
                                                      ?.profile_image
                                                  : Images.userimg
                                              }
                                              alt=""
                                            />
                                          </span>
                                          <div className="ms-3">
                                            <p className="colorWhite subtext mb-0">
                                              {data?.created_by?.full_name}
                                            </p>
                                            <p className="colorWhite subtext mb-0 textLiveStreaming">
                                              {data?.comment}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            })}
                          </div>

                          <div className="py-3 px-3  chatInputbox chatInputboxResp">
                            <form
                              onSubmit={(event) => handleSendComments(event)}
                            >
                              <input
                                className="text"
                                type="text"
                                placeholder="Type here..."
                              />

                              <button className="send-live-msg" type="submit">
                                <img src={Images.adminsend} alt="" />
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
      <CustomModal
        key={key}
        show={modalDetail.show}
        backdrop="static"
        showCloseBtn={false}
        isRightSideModal={false}
        mediumWidth={false}
        className={modalDetail.flag === "confirm" ? "confirm" : ""}
        child={
          modalDetail.flag === "confirm" ? (
            <ConfirmModal
              closeModal={() => {
                handleOnCloseModal();
              }}
            />
          ) : (
            ""
          )
        }
        onCloseModal={() => handleOnCloseModal()}
      />
    </>
  );
};

export default LiveStreaming;
